import { Box, Card, CircularProgress, Modal } from '@mui/material'
import React from 'react'
import HeaderUI from '../../SubComponent/Header/UI/Browser/Header'
import IndexUI from '../../SubComponent/Main/Index/UI/Browser/Index'
import HomeDispatch from './model'
import HomeState from '../../State/HomeState'


class Home extends React.PureComponent<{}>{
    componentDidMount(): void {
        let dispatcher: HomeDispatch = (this.props as any).dispatcher
        dispatcher.fetch()
    }
    render() {

        let state: HomeState = (this.props as any).state

        return (
            <Box flexDirection='column' display="flex">
                <div>
                    {/* HEADER    */}
                    <HeaderUI />
                    {/* HEADER    */}

                    <Modal open={state.loading} onClose={() => { }}>
                        <Box sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 'fit-content',
                            bgcolor: "background.paper",
                            border: "2px solid #000",
                            boxShadow: 24,
                            p: 4,
                        }} >
                            <CircularProgress />
                        </Box>
                    </Modal>

                    <Box height="100vh" display="flex" flexDirection="column">
                        <Card variant="outlined" sx={{ height: '100%', borderRadius: '24px', borderColor: 'transparent', bgcolor: '#f5f5f5', ml: 5, mr: 5, mt: '78px', mb: 2, p: 1 }} >
                            <Box flexDirection='row' sx={{ height: '100%', width: '100%' }} display="flex">
                                <Box sx={{ width: '100%', height: '100%' }}><IndexUI /></Box>

                            </Box>
                        </Card>
                    </Box>
                </div >
            </Box>
        )
    }
}

export default Home